<template>
  <nav
    v-if="selectedNeighborhoodIds && selectedNeighborhoodIds.length"
    aria-label="Breadcrumb"
    class="breadcrumb mobhide"
  >
    <a
      :class="[{ 'pointer-none': isKioskMode }, 'breadcrumb-item']"
      @click="!isKioskMode && breadCrumbsNavigation(communityUrl)"
    >
      Communities<span></span>
    </a>
    <p class="breadcrumb-item not-clickable" v-if="communityName">{{ communityName }}</p>
    <a
      v-if="selectedNeighborhoodData.neighborhood_name"
      class="breadcrumb-item"
      @click="
        !isKioskMode &&
          breadCrumbsNavigation(selectedNeighborhoodData.neighborhood_url)
      "
    >
      {{ selectedNeighborhoodData.neighborhood_name }}
    </a>
    <span class="breadcrumb-item">Home Sites</span>
  </nav>

  <nav v-else-if="communityUrl" aria-label="Breadcrumb" class="breadcrumb mobhide">
    <a
      :class="[{ 'pointer-none': isKioskMode }, 'breadcrumb-item']"
      @click="!isKioskMode && breadCrumbsNavigation(communityUrl)"
    >
      Communities
    </a>
    <p class="breadcrumb-item not-clickable" v-if="communityName">{{ communityName }}</p>
    <span class="breadcrumb-item">Home Sites</span>
  </nav>
</template>

<script lang="ts" setup>
import { ref, watch, onMounted, toRefs } from 'vue';
import type { Sibling } from '@/types';

interface Props {
  communityUrl?: string;
  communityName?: string;
  isKioskMode: boolean;
  neighborhoods?: Sibling[];
  selectedNeighborhoodIds: string[];
}

const props = withDefaults(defineProps<Props>(), {
  neighborhoods: () => [] as Sibling[],
});
const {
  communityUrl,
  communityName,
  isKioskMode,
  neighborhoods,
  selectedNeighborhoodIds,
} = toRefs(props);

const selectedNeighborhoodData = ref<Sibling>({} as Sibling);

watch([neighborhoods, selectedNeighborhoodIds], () => {
  setNeighborhoodInfo();
}, {
  deep: true
});

onMounted(() => {
  setNeighborhoodInfo();
});

const setNeighborhoodInfo = () => {
  if (selectedNeighborhoodIds.value.length) {
    const neighborhood = neighborhoods.value.find(
      (n) => n.id === selectedNeighborhoodIds.value[0]
    );
    selectedNeighborhoodData.value = neighborhood ?? ({} as Sibling);
  } else {
    selectedNeighborhoodData.value = {} as Sibling;
  }
};

const breadCrumbsNavigation = (path = '') => {
  if (path) window.open(path, '_blank');
};
</script>

<style lang="scss" scoped>
.not-clickable {
  @include font(10px, 400);
  pointer-events: none;
  color: $white;
}
</style>
